import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  TaskTime,
  TaskTimeLabel,
  TaskTimeDuration,
  TaskCardWrapper,
  TaskTitle,
  TaskMatter,
  TaskUser,
} from '../../assets/styles/components/criticalCard.styled';
import { ArrowRight, Briefcase, User } from '../icons';
import { IconButton, Text } from '../Ant';
import { useUser } from '../../context/UserContext';
import { ITask } from '../../interface/tasks';
import { currentUserHasRightsToCriticalTask } from '../../constants/taskUtility';
import { getMatterIconClass } from '../../constants/utilityFunctions';

interface TaskCardProps {
  time: string;
  duration?: string;
  title: string;
  matter?: string;
  user: string;
  isCompleted?: boolean;
  onClick: () => void;
  task: ITask;
}

const CriticalCard = ({
  time,
  duration,
  title,
  matter,
  user,
  isCompleted,
  onClick,
  task,
}: TaskCardProps) => {
  const { t } = useTranslation();
  const { userDetails } = useUser();
  const userHasRightsToCriticalTask = currentUserHasRightsToCriticalTask(
    task,
    userDetails?.userType,
    userDetails?.id,
  );
  return (
    <Flex align="center" gap={15} onClick={userHasRightsToCriticalTask ? onClick : undefined}>
      <TaskTime>
        <TaskTimeLabel>{time}</TaskTimeLabel>
        <TaskTimeDuration>{duration}</TaskTimeDuration>
      </TaskTime>
      <TaskCardWrapper
        className={isCompleted || !userHasRightsToCriticalTask ? 'is-completed' : ''}
      >
        <Flex vertical gap={5}>
          {userHasRightsToCriticalTask && <TaskTitle>{title}</TaskTitle>}
          {matter && userHasRightsToCriticalTask && (
            <TaskMatter>
              <Briefcase className={getMatterIconClass(task?.matter?.invoiceableType ?? '')} />
              <Text
                $fontsize="11px"
                $lineheight="14px"
                $color="description"
                className="lineclamp-2"
              >
                {matter}
              </Text>
            </TaskMatter>
          )}
          <TaskUser>
            <User />
            <Text $fontsize="11px" $lineheight="17px" $color="description">
              {user}
            </Text>
          </TaskUser>
        </Flex>
        {userHasRightsToCriticalTask && (
          <IconButton
            aria-label={t('transaction:goDetail')}
            onClick={onClick}
            type="text"
            icon={<ArrowRight />}
            className="clear-icon-btn"
          />
        )}
      </TaskCardWrapper>
    </Flex>
  );
};

export default CriticalCard;
